import { createSlice } from '@reduxjs/toolkit';
import { ApiSortDirection } from '../../api';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { ALL_VALUE } from '../helper';
import { reasonDefault } from '../reasonsHelper';

export interface SelectOption {
  key: string;
  value: number | string;
  label: string;
}

export interface OrderBy {
  attribute: string | undefined;
  direction: ApiSortDirection | undefined;
}

export interface FiltersState {
  selectedAssignee: DropdownOption | undefined;
  selectedStatus: DropdownOption | undefined;
  selectedReason: DropdownOption | undefined;
  selectedMultiReason: DropdownOption[] | undefined;
  selectedScenarioType: DropdownOption | undefined;
  orderBy: OrderBy;
}

export const initialState: FiltersState = {
  selectedAssignee: undefined,
  selectedStatus: undefined,
  selectedReason: undefined,
  selectedMultiReason: undefined,
  selectedScenarioType: undefined,
  orderBy: {
    attribute: undefined,
    direction: undefined,
  },
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateSelectedAssignee: (state, action) => {
      state.selectedAssignee = action.payload;
    },
    updateSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    updateSelectedReason: (state, action) => {
      state.selectedReason = action.payload;
    },
    updateSelectedMultiReason: (state, action) => {
      if (action.payload.length === 0) {
        state.selectedMultiReason = [reasonDefault];
        return;
      }

      const elementsAdded = action.payload as DropdownOption[];
      const elementAdded = elementsAdded[elementsAdded.length - 1];

      if (elementAdded.key === ALL_VALUE) {
        state.selectedMultiReason = [reasonDefault];
        return;
      }

      const withoutAll = elementsAdded.filter((a) => a.key !== ALL_VALUE);
      state.selectedMultiReason = withoutAll as any;
    },
    updateSelectedScenarioType: (state, action) => {
      state.selectedScenarioType = action.payload;
    },
    updateOrderBy: (state, action) => {
      state.orderBy = action.payload;
    },
  },
});

const { actions, reducer } = filtersSlice;

export const {
  updateSelectedAssignee,
  updateSelectedReason,
  updateSelectedMultiReason,
  updateSelectedStatus,
  updateSelectedScenarioType,
  updateOrderBy,
} = actions;
export default reducer;
